import type { AxiosPromise } from 'axios';
import client from '../client';
import payments from './payments';

const buildUrl = (path?: string | number) => (path ? `/merchants/${path}` : '/merchants');

export default {
  index: () => client.get(buildUrl()),
  show: (id: number): AxiosPromise => {
    return client.get(buildUrl(id));
  },
  update: (
    id: number,
    updates: { invoiceEmail?: string; notificationEmail?: string; phone?: string },
  ): AxiosPromise => {
    return client.patch(buildUrl(id), updates);
  },
  payments,
  platformOnboard: (id: number): AxiosPromise => {
    return client.post(`${buildUrl(id)}/platform-onboard`);
  },
};
